import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Close } from "src/components";
import { UserFavoriteItem } from "src/models";
import { ProfileData, ProfileDataAction } from "src/store";
import LazyLoad from "vanilla-lazyload";
import phPackage from "src/assets/static/img/main/icons/ph_package.png";

export const TeamChip: React.FC<UserFavoriteItem> = (item) => {

    const dispatch = useDispatch();
    const data: ProfileData = useSelector((state: any) => state.ProfileDataState);
    const { actionLoading } = data.favorites;

    const onRemove = () => dispatch(ProfileDataAction.removeFavorite(item));

    useEffect(() => {
        const lazyload = new LazyLoad({
            elements_selector: `.lazy[data-name='${item.team}']`,
            callback_error: (element: HTMLElement) => {
                const placeholder = element.getAttribute("data-placeholder");
                if (placeholder) element.setAttribute("src", placeholder);
            },
        });

        lazyload.update();

    }, [item]);



    return (
        <div className="d-flex sport-item">
            <img alt=""
                width={32} height={32}
                data-src={item.icon}
                data-placeholder={phPackage}
                data-name={item.team}
                src={phPackage}
                className="large logo lazy" />
            <div className="d-flex flex-column">
                <span>{item.team}</span>
                <span>{item.sport}</span>
            </div>
            <button disabled={actionLoading} onClick={onRemove}><Close /></button>
        </div>
    );
};